import * as axios from 'axios';

export const GET_USER_LOGIN_STATUS_START = "GET_USER_LOGIN_STATUS_START";
export const GET_USER_LOGIN_STATUS = "GET_USER_LOGIN_STATUS";

export const getUserLoginStatus = () => dispatch => {
    dispatch({type: GET_USER_LOGIN_STATUS_START});

    const payload = axios.get('/api/auth-status');
    dispatch({
        type: GET_USER_LOGIN_STATUS,
        payload
    });
};

export const SESSION_EXPIRED = "SESSION_EXPIRED";

export const sessionExpired = () => ({type: SESSION_EXPIRED});



// WEBPACK FOOTER //
// ./src/containers/login/LoginActions.js